import { getFileNameFromContentDisposition } from "@/common/helpers/file";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";

export const VEHICLE_SNAPSHOT_DOWNLOAD_API_PATH = "/v1/vehicle/{uuid}/snapshot/download" as const;

export interface VehicleSnapshotDownload {
  blob: Blob;
  fileName: string;
}

async function downloadVehicleSnapshot(uuid: string): Promise<VehicleSnapshotDownload> {
  const apiPath = VEHICLE_SNAPSHOT_DOWNLOAD_API_PATH.replace("{uuid}", uuid);
  const response = await alphartisApiAxios.get<Blob>(apiPath, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    fileName: getFileNameFromContentDisposition(
      response.headers["content-disposition"],
      `DAT-vehicle-snapshot-${uuid}.json`,
    ),
  };
}

export function useVehicleSnapshotDownloadMutation() {
  return useMutation<VehicleSnapshotDownload, Error, string>({
    mutationFn: downloadVehicleSnapshot,
  });
}
